import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';

export default class AccountActivityNewRouteComponent extends Component {
  @service declare router: RouterService;

  onLinkingSuccess = () => {
    this.router.transitionTo('authenticated.observability.upload');
  };

  didCancel = () => {
    this.router.transitionTo('authenticated.observability.upload');
  };

  <template>
    <VStack>
      <PageHeader @title={{t "account_linking.add_account"}} @sticky={{false}} />
    </VStack>
  </template>
}
